var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar'),_c('b-container',{staticClass:"text-justify mt-3",attrs:{"fluid":"md"}},[_c('Business')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }